import { useDispatch } from "react-redux";

import { QuickSearchModal } from "components/search/QuickSearchModal/parts/QuickSearchModal";
import { indexLookup } from "lib/search/indexLookup";
import { useIsSearchVisibile } from "store/search/searchSelector";
import { searchActions } from "store/search/searchSlice";

import { SearchContextType } from "../search/types";

const searchOptions: SearchContextType = {
  initialSearchType: "Books",
  searchTypes: [
    "Books",
    "Authors",
    "Series",
    "Lists",
    "Prompts",
    "Characters",
    "Users",
    "Publishers",
  ],
  searchMultipleSources: true,
  initialUiState: {
    [indexLookup("Books")]: {
      query: "",
    },
  },
};

const QuickSearchModalWrapper = () => {
  const isVisible = useIsSearchVisibile();
  const dispatch = useDispatch();

  return (
    <QuickSearchModal
      isOpen={isVisible}
      onClose={() => dispatch(searchActions.setSearchVisible(false))}
      searchOptions={searchOptions}
    />
  );
};

export default QuickSearchModalWrapper;
